"use strict";

var _interopRequireDefault = require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateAchievement = exports.getAchievements = exports.getAchievementById = exports.deleteAchievement = exports.defaultAchievementData = exports.createAchievement = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
const defaultAchievementData = exports.defaultAchievementData = {
  id: 0,
  enabled: true,
  name: '',
  priority: 0,
  code: '',
  achievementIcon: '',
  startColour: '',
  endColour: '',
  description: ''
};
const getAchievements = params => (0, _request.default)({
  url: '/achievements',
  method: 'get',
  params
});
exports.getAchievements = getAchievements;
const getAchievementById = id => (0, _request.default)({
  url: `/achievements/${id}`,
  method: 'get'
});
exports.getAchievementById = getAchievementById;
const updateAchievement = (id, data) => (0, _request.default)({
  url: `/achievements/${id}`,
  method: 'patch',
  data
});
exports.updateAchievement = updateAchievement;
const deleteAchievement = id => (0, _request.default)({
  url: `/achievements/${id}`,
  method: 'delete'
});
exports.deleteAchievement = deleteAchievement;
const createAchievement = data => (0, _request.default)({
  url: '/achievements/',
  method: 'post',
  data
});
exports.createAchievement = createAchievement;